import { Controller } from "@hotwired/stimulus"

// data-controller="countdown"
// data-countdown-expiry-value="2026-01-19T10:10:00Z"
// data-countdown-target="timer" data-countdown-target="alert"
export default class extends Controller {
  static values = {
    expiry: String,
  }

  static targets = ["timer", "alert"]

  connect() {
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.stop()
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  tick() {
    const expiry = new Date(this.expiryValue)
    const now = new Date()
    const diffMs = expiry - now

    if (Number.isNaN(expiry.getTime())) {
      this.timerTarget.textContent = "–"
      this.showAlert("Invalid expiry")
      this.stop()
      return
    }

    if (diffMs <= 0) {
      this.timerTarget.textContent = "Expired"
      this.showAlert()
      this.stop()
      return
    }

    const totalSeconds = Math.floor(diffMs / 1000)
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0")
    const seconds = String(totalSeconds % 60).padStart(2, "0")
    this.timerTarget.textContent = `${minutes}:${seconds}`
  }

  showAlert(message = "QR code has expired.") {
    if (this.hasAlertTarget) {
      this.alertTarget.classList.remove("hidden")
      const textEl = this.alertTarget.querySelector("[data-countdown-target='alertText']")
      if (textEl) textEl.textContent = message
    }
  }
}
